import { CredenciadaCodeActions } from "../actions";

const initialState = {
  totalAccess: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
};

export default function credenciadaCode(state = initialState, action) {
  switch (action.type) {
    case CredenciadaCodeActions.ACTION_SAVE_TOTAL_CREDENCIADA_CODE:
      return {
        ...state,
        totalAccess: action.payload,
      };
    default:
      return state;
  }
}

export function getTotalAccesses(state) {
  return state.credenciadaCode.totalAccess;
}
